const initialState = {
  products: []
};

const bundleProducts = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default bundleProducts;
